export const comCopy = {
  com_layout_title: "Como configurar TypeScript",
  com_layout_description: "",
  com_headline: "Conecta con nosotros",
  com_connect_online: "En línea",
  com_connect_online_description:
    "Cuéntanos que está funcionando bien, qué quiere que se añada o se mejore, y entérese de las nuevas actualizaciones.",
  com_online_stack_overflow_desc:
    "Entra en contacto con otros y haz preguntas sobre Typescript en",
  com_online_stack_overflow_tag: "usando la etiqueta",
  com_online_discord_header: "Chat",
  com_online_discord_desc:
    "Chatea con otros usuarios de TypeScript en el Chat de la Comunidad TypeScript.",
  com_online_github_desc:
    "¿Encontraste un error, o quieres darnos una respuesta constructiva?",
  com_online_github_href: "Cuéntanos en GitHub",
  com_online_twitter_desc: "Mantente al día. Síguenos en Twitter",
  com_online_blog_desc:
    "Aprenda acerca de los últimos desarrollos de TypeScript a través de nuestro",
  com_online_typed_desc: "Archivos de definiciones de TypeScript.",
  com_online_typed_href: "Navegue por los miles de",
  com_online_typed_available_for:
    "disponibles para las librerías y marcos de trabajo comunes.",
  com_person: "Conéctate en persona",
  com_conferences: "Conferencias",
  com_conferences_alt_img: "logo de ",
}
